export default __webpack_public_path__ + "mail.b10a4760f5f7c0a1.svg";